export default __webpack_public_path__ + "static/media/MorganWorkman.c31386ac.png";